import { render, staticRenderFns } from "./Coverage.vue?vue&type=template&id=68124605&scoped=true"
import script from "./Coverage.vue?vue&type=script&lang=js"
export * from "./Coverage.vue?vue&type=script&lang=js"
import style0 from "./Coverage.vue?vue&type=style&index=0&id=68124605&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68124605",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68124605')) {
      api.createRecord('68124605', component.options)
    } else {
      api.reload('68124605', component.options)
    }
    module.hot.accept("./Coverage.vue?vue&type=template&id=68124605&scoped=true", function () {
      api.rerender('68124605', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proposal/Coverage.vue"
export default component.exports